export default "__VITE_ASSET__6_Gr0t6k__"